module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"startPlaceholder":"from","endPlaceholder":"until"},"et":{"startPlaceholder":"from","endPlaceholder":"until"},"ru":{"startPlaceholder":"from","endPlaceholder":"until"}}')
  delete Component.options._Ctor
}
